<template>
  <MonitoringStatCardBlock
    :definition="definition"
    :data="data"
    :urgency="urgency"
    :always-clickable="true"
    :loading="loading"
    @drill="$emit('drill', $event)"
  />
</template>

<script>
  import MonitoringStatCardBlock from './MonitoringStatCardBlock.vue';
  // NOTE: just a wrapper
  export default {
    name: 'PendingAcceptanceBlock',
    components: { MonitoringStatCardBlock },
    props: {
      definition: {
        type: Object,
        required: true,
      },
      data: {
        type: Object,
        default: () => ({}),
      },
      urgency: {
        type: String,
        default: 'warning',
        validator: (v) => ['critical', 'warning', 'safe'].includes(v),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
